/**
 * Iter-155B.0 — Trust Layer reassurance block.
 *
 * Single source of truth for the calm "nothing is ever deleted"
 * language used across every revision-related surface (diff dialog,
 * result screen, upload preflight, omitted banner, panel empty
 * state). Centralising the wording here means we can never drift —
 * if the legal/spec copy changes, it changes in one place.
 *
 * Visual style is deliberately calm:
 *   - emerald-tinted border (positive, not warning)
 *   - low-contrast background (doesn't compete with action)
 *   - shield icon (safety, not alert)
 */
import { ShieldCheck } from "lucide-react";

export default function RevisionReassurance({
    variant = "default",
    testid = "revision-reassurance",
    className = "",
}) {
    // "compact" omits the heading and is used inside dense modals.
    const isCompact = variant === "compact";
    return (
        <div
            data-testid={testid}
            className={`rounded-xl border border-emerald-300 bg-emerald-50 dark:border-emerald-500/50 dark:bg-emerald-500/20 p-3 flex items-start gap-3 ${className}`}
        >
            <ShieldCheck
                size={16}
                className="text-emerald-700 dark:text-emerald-200 mt-0.5 shrink-0"
                aria-hidden
            />
            <div className="text-[13px] text-emerald-900 dark:text-emerald-50 leading-relaxed">
                {!isCompact ? (
                    <p
                        className="font-semibold text-emerald-900 dark:text-emerald-100 text-[11px] uppercase tracking-[0.2em] mb-1"
                        data-testid={`${testid}-title`}
                    >
                        Your work is safe
                    </p>
                ) : null}
                <p
                    data-testid={`${testid}-body`}
                    className="text-emerald-900 dark:text-emerald-50"
                >
                    Nothing is ever deleted. Photos, notes and looks
                    always stay attached to their scenes. Omitted
                    scenes remain visible and can be reinstated.
                </p>
            </div>
        </div>
    );
}
